import _toConsumableArray from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import PropTypes from 'prop-types';
import { Animated, NativeModules, StyleSheet, View, ScrollView, Platform, I18nManager } from 'react-native';
import TouchableItem from './TouchableItem';
import { SceneRendererPropType } from './PropTypes';
var useNativeDriver = Boolean(NativeModules.NativeAnimatedModule);

var TabBar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TabBar, _React$Component);

  function TabBar(_props) {
    var _this;

    _classCallCheck(this, TabBar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TabBar).call(this, _props));

    _defineProperty(_assertThisInitialized(_this), "_isIntial", true);

    _defineProperty(_assertThisInitialized(_this), "_isManualScroll", false);

    _defineProperty(_assertThisInitialized(_this), "_isMomentumScroll", false);

    _defineProperty(_assertThisInitialized(_this), "_startTrackingPosition", function () {
      _this._offsetXListener = _this.props.offsetX.addListener(function (_ref) {
        var value = _ref.value;
        _this._lastOffsetX = value;

        _this._handlePosition();
      });
      _this._panXListener = _this.props.panX.addListener(function (_ref2) {
        var value = _ref2.value;
        _this._lastPanX = value;

        _this._handlePosition();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_stopTrackingPosition", function () {
      _this.props.offsetX.removeListener(_this._offsetXListener);

      _this.props.panX.removeListener(_this._panXListener);
    });

    _defineProperty(_assertThisInitialized(_this), "_handlePosition", function () {
      var _this$props = _this.props,
          navigationState = _this$props.navigationState,
          layout = _this$props.layout;

      if (layout.width === 0) {
        // Don't do anything if we don't have layout yet
        return;
      }

      var panX = typeof _this._lastPanX === 'number' ? _this._lastPanX : 0;
      var offsetX = typeof _this._lastOffsetX === 'number' ? _this._lastOffsetX : -navigationState.index * layout.width;
      var value = (panX + offsetX) / -(layout.width || 0.001);

      _this._adjustScroll(value);
    });

    _defineProperty(_assertThisInitialized(_this), "_renderLabel", function (scene) {
      if (typeof _this.props.renderLabel !== 'undefined') {
        return _this.props.renderLabel(scene);
      }

      var label = _this.props.getLabelText(scene);

      if (typeof label !== 'string') {
        return null;
      }

      return React.createElement(Animated.Text, {
        style: [styles.tabLabel, _this.props.labelStyle]
      }, label);
    });

    _defineProperty(_assertThisInitialized(_this), "_renderIndicator", function (props) {
      if (typeof _this.props.renderIndicator !== 'undefined') {
        return _this.props.renderIndicator(props);
      }

      var width = props.width,
          position = props.position,
          navigationState = props.navigationState;
      var translateX = Animated.multiply(Animated.multiply(position.interpolate({
        inputRange: [-1, navigationState.routes.length],
        outputRange: [-1, navigationState.routes.length],
        extrapolate: 'clamp'
      }), width), I18nManager.isRTL ? -1 : 1);
      return React.createElement(Animated.View, {
        style: [styles.indicator, {
          width: width,
          transform: [{
            translateX: translateX
          }]
        }, _this.props.indicatorStyle]
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_getTabWidth", function (props) {
      var layout = props.layout,
          navigationState = props.navigationState,
          tabStyle = props.tabStyle;
      var flattened = StyleSheet.flatten(tabStyle);

      if (flattened) {
        switch (typeof flattened.width) {
          case 'number':
            return flattened.width;

          case 'string':
            if (flattened.width.endsWith('%')) {
              var width = parseFloat(flattened.width);

              if (Number.isFinite(width)) {
                return layout.width * (width / 100);
              }
            }

        }
      }

      if (props.scrollEnabled) {
        return layout.width / 5 * 2;
      }

      return layout.width / navigationState.routes.length;
    });

    _defineProperty(_assertThisInitialized(_this), "_handleTabPress", function (_ref3) {
      var route = _ref3.route;
      _this._pendingIndex = _this.props.navigationState.routes.indexOf(route);

      if (_this.props.onTabPress) {
        _this.props.onTabPress({
          route: route
        });
      }

      _this.props.jumpTo(route.key);
    });

    _defineProperty(_assertThisInitialized(_this), "_handleTabLongPress", function (_ref4) {
      var route = _ref4.route;

      if (_this.props.onTabLongPress) {
        _this.props.onTabLongPress({
          route: route
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_normalizeScrollValue", function (props, value) {
      var layout = props.layout,
          navigationState = props.navigationState;

      var tabWidth = _this._getTabWidth(props);

      var tabBarWidth = Math.max(tabWidth * navigationState.routes.length, layout.width);
      var maxDistance = tabBarWidth - layout.width;
      return Math.max(Math.min(value, maxDistance), 0);
    });

    _defineProperty(_assertThisInitialized(_this), "_getScrollAmount", function (props, i) {
      var layout = props.layout;

      var tabWidth = _this._getTabWidth(props);

      var centerDistance = tabWidth * (i + 1 / 2);
      var scrollAmount = centerDistance - layout.width / 2;
      return _this._normalizeScrollValue(props, scrollAmount);
    });

    _defineProperty(_assertThisInitialized(_this), "_adjustScroll", function (value) {
      if (_this.props.scrollEnabled) {
        global.cancelAnimationFrame(_this._scrollResetCallback);
        _this._scrollView && _this._scrollView.scrollTo({
          x: _this._normalizeScrollValue(_this.props, _this._getScrollAmount(_this.props, value)),
          animated: !_this._isIntial // Disable animation for the initial render

        });
        _this._isIntial = false;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_resetScroll", function (value) {
      var animated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (_this.props.scrollEnabled) {
        global.cancelAnimationFrame(_this._scrollResetCallback);
        _this._scrollResetCallback = global.requestAnimationFrame(function () {
          _this._scrollView && _this._scrollView.scrollTo({
            x: _this._getScrollAmount(_this.props, value),
            animated: animated
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleBeginDrag", function () {
      // onScrollBeginDrag fires when user touches the ScrollView
      _this._isManualScroll = true;
      _this._isMomentumScroll = false;
    });

    _defineProperty(_assertThisInitialized(_this), "_handleEndDrag", function () {
      // onScrollEndDrag fires when user lifts his finger
      // onMomentumScrollBegin fires after touch end
      // run the logic in next frame so we get onMomentumScrollBegin first
      global.requestAnimationFrame(function () {
        if (_this._isMomentumScroll) {
          return;
        }

        _this._isManualScroll = false;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleMomentumScrollBegin", function () {
      // onMomentumScrollBegin fires on flick, as well as programmatic scroll
      _this._isMomentumScroll = true;
    });

    _defineProperty(_assertThisInitialized(_this), "_handleMomentumScrollEnd", function () {
      // onMomentumScrollEnd fires when the scroll finishes
      _this._isMomentumScroll = false;
      _this._isManualScroll = false;
    });

    var initialVisibility = 1;

    if (_this.props.scrollEnabled) {
      var tabWidth = _this._getTabWidth(_this.props);

      if (!tabWidth) {
        initialVisibility = 0;
      }
    }

    var initialOffset = _this.props.scrollEnabled && _this.props.layout.width ? {
      x: _this._getScrollAmount(_this.props, _this.props.navigationState.index),
      y: 0
    } : undefined;
    _this.state = {
      visibility: new Animated.Value(initialVisibility),
      scrollAmount: new Animated.Value(0),
      initialOffset: initialOffset
    };
    return _this;
  }

  _createClass(TabBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.scrollEnabled && this._startTrackingPosition();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevTabWidth = this._getTabWidth(prevProps);

      var currentTabWidth = this._getTabWidth(this.props);

      var pendingIndex = typeof this._pendingIndex === 'number' ? this._pendingIndex : this.props.navigationState.index;
      this._pendingIndex = null;

      if (prevTabWidth !== currentTabWidth && currentTabWidth) {
        this.state.visibility.setValue(1);
      }

      if (prevProps.navigationState.routes.length !== this.props.navigationState.routes.length || prevProps.layout.width !== this.props.layout.width) {
        this._resetScroll(this.props.navigationState.index, false);
      } else if (prevProps.navigationState.index !== pendingIndex) {
        this._resetScroll(this.props.navigationState.index);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._stopTrackingPosition();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          position = _this$props2.position,
          navigationState = _this$props2.navigationState,
          scrollEnabled = _this$props2.scrollEnabled,
          bounces = _this$props2.bounces;
      var routes = navigationState.routes;

      var tabWidth = this._getTabWidth(this.props);

      var tabBarWidth = tabWidth * routes.length; // Prepend '-1', so there are always at least 2 items in inputRange

      var inputRange = [-1].concat(_toConsumableArray(routes.map(function (x, i) {
        return i;
      })));
      var translateX = Animated.multiply(this.state.scrollAmount, -1);
      return React.createElement(Animated.View, {
        style: [styles.tabBar, this.props.style]
      }, React.createElement(Animated.View, {
        pointerEvents: "none",
        style: [styles.indicatorContainer, scrollEnabled ? {
          width: tabBarWidth,
          transform: [{
            translateX: translateX
          }]
        } : null]
      }, this._renderIndicator(_objectSpread({}, this.props, {
        width: tabWidth
      }))), React.createElement(View, {
        style: styles.scroll
      }, React.createElement(Animated.ScrollView, {
        horizontal: true,
        keyboardShouldPersistTaps: "handled",
        scrollEnabled: scrollEnabled,
        bounces: bounces,
        alwaysBounceHorizontal: false,
        scrollsToTop: false,
        showsHorizontalScrollIndicator: false,
        automaticallyAdjustContentInsets: false,
        overScrollMode: "never",
        contentContainerStyle: [styles.tabContent, scrollEnabled ? null : styles.container],
        scrollEventThrottle: 1,
        onScroll: Animated.event([{
          nativeEvent: {
            contentOffset: {
              x: this.state.scrollAmount
            }
          }
        }], {
          useNativeDriver: useNativeDriver
        }),
        onScrollBeginDrag: this._handleBeginDrag,
        onScrollEndDrag: this._handleEndDrag,
        onMomentumScrollBegin: this._handleMomentumScrollBegin,
        onMomentumScrollEnd: this._handleMomentumScrollEnd,
        contentOffset: this.state.initialOffset,
        ref: function ref(el) {
          return _this2._scrollView = el && el.getNode();
        }
      }, routes.map(function (route, i) {
        var outputRange = inputRange.map(function (inputIndex) {
          return inputIndex === i ? 1 : 0.7;
        });
        var opacity = Animated.multiply(_this2.state.visibility, position.interpolate({
          inputRange: inputRange,
          outputRange: outputRange
        }));

        var label = _this2._renderLabel({
          route: route
        });

        var icon = _this2.props.renderIcon ? _this2.props.renderIcon({
          route: route
        }) : null;
        var badge = _this2.props.renderBadge ? _this2.props.renderBadge({
          route: route
        }) : null;
        var tabStyle = {};
        tabStyle.opacity = opacity;

        if (icon) {
          if (label) {
            tabStyle.paddingTop = 8;
          } else {
            tabStyle.padding = 12;
          }
        }

        var passedTabStyle = StyleSheet.flatten(_this2.props.tabStyle);
        var isWidthSet = passedTabStyle && typeof passedTabStyle.width !== 'undefined' || scrollEnabled === true;
        var tabContainerStyle = {};

        if (isWidthSet) {
          tabStyle.width = tabWidth;
        }

        if (passedTabStyle && typeof passedTabStyle.flex === 'number') {
          tabContainerStyle.flex = passedTabStyle.flex;
        } else if (!isWidthSet) {
          tabContainerStyle.flex = 1;
        }

        var accessibilityLabel = _this2.props.getAccessibilityLabel({
          route: route
        });

        accessibilityLabel = typeof accessibilityLabel !== 'undefined' ? accessibilityLabel : _this2.props.getLabelText({
          route: route
        });
        var isFocused = i === navigationState.index;
        return React.createElement(TouchableItem, {
          borderless: true,
          key: route.key,
          testID: _this2.props.getTestID({
            route: route
          }),
          accessible: _this2.props.getAccessible({
            route: route
          }),
          accessibilityLabel: accessibilityLabel,
          accessibilityTraits: isFocused ? ['button', 'selected'] : 'button',
          accessibilityComponentType: "button",
          accessibilityRole: "button",
          accessibilityStates: isFocused ? ['selected'] : [],
          pressColor: _this2.props.pressColor,
          pressOpacity: _this2.props.pressOpacity,
          delayPressIn: 0,
          onPress: function onPress() {
            return _this2._handleTabPress({
              route: route
            });
          },
          onLongPress: function onLongPress() {
            return _this2._handleTabLongPress({
              route: route
            });
          },
          style: tabContainerStyle
        }, React.createElement(View, {
          pointerEvents: "none",
          style: styles.container
        }, React.createElement(Animated.View, {
          style: [styles.tabItem, tabStyle, passedTabStyle, styles.container]
        }, icon, label), badge ? React.createElement(Animated.View, {
          style: [styles.badge, {
            opacity: _this2.state.visibility
          }]
        }, badge) : null));
      }))));
    }
  }]);

  return TabBar;
}(React.Component);

_defineProperty(TabBar, "propTypes", _objectSpread({}, SceneRendererPropType, {
  scrollEnabled: PropTypes.bool,
  bounces: PropTypes.bool,
  pressColor: TouchableItem.propTypes.pressColor,
  pressOpacity: TouchableItem.propTypes.pressOpacity,
  getLabelText: PropTypes.func,
  getAccessible: PropTypes.func,
  getAccessibilityLabel: PropTypes.func,
  getTestID: PropTypes.func,
  renderIcon: PropTypes.func,
  renderLabel: PropTypes.func,
  renderIndicator: PropTypes.func,
  onTabPress: PropTypes.func,
  onTabLongPress: PropTypes.func,
  labelStyle: PropTypes.any,
  style: PropTypes.any
}));

_defineProperty(TabBar, "defaultProps", {
  getLabelText: function getLabelText(_ref5) {
    var route = _ref5.route;
    return typeof route.title === 'string' ? route.title.toUpperCase() : route.title;
  },
  getAccessible: function getAccessible(_ref6) {
    var route = _ref6.route;
    return typeof route.accessible !== 'undefined' ? route.accessible : true;
  },
  getAccessibilityLabel: function getAccessibilityLabel(_ref7) {
    var route = _ref7.route;
    return route.accessibilityLabel;
  },
  getTestID: function getTestID(_ref8) {
    var route = _ref8.route;
    return route.testID;
  }
});

export { TabBar as default };
var styles = StyleSheet.create({
  container: {
    flex: 1
  },
  scroll: {
    overflow: Platform.OS === 'web' ? 'auto' : 'scroll'
  },
  tabBar: {
    backgroundColor: '#2196f3',
    elevation: 4,
    shadowColor: 'black',
    shadowOpacity: 0.1,
    shadowRadius: StyleSheet.hairlineWidth,
    shadowOffset: {
      height: StyleSheet.hairlineWidth
    },
    // We don't need zIndex on Android, disable it since it's buggy
    zIndex: Platform.OS === 'android' ? 0 : 1
  },
  tabContent: {
    flexDirection: 'row',
    flexWrap: 'nowrap'
  },
  tabLabel: {
    backgroundColor: 'transparent',
    color: 'white',
    margin: 8
  },
  tabItem: {
    flex: 1,
    padding: 8,
    alignItems: 'center',
    justifyContent: 'center'
  },
  badge: {
    position: 'absolute',
    top: 0,
    right: 0
  },
  indicatorContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },
  indicator: {
    backgroundColor: '#ffeb3b',
    position: 'absolute',
    left: 0,
    bottom: 0,
    right: 0,
    height: 2
  }
});